export default {
  // Cookies page
  cookiesTitle: 'Cookie Policy',
  cookiesSubtitle: 'Manage your cookie preferences and tracking consent.',
  cookiesUpdated: 'last updated: 10 Jan 2026',
  cookiesManifest: 'Detailed manifest',
  cookiesPrivacyPre: 'For more information on how we handle your data, please review our full',
  cookiesPrivacyLink: 'Privacy Policy',
  cookiesIntro:
    'PixelKey uses cookies and similar technologies to keep the site stable and secure, enhance your experience, and analyze how the platform is used. Manage your preferences below.',
  cookiesPrefsTitle: 'Your preferences',
  cookiesRowEssential: 'Essential',
  cookiesRowEssentialDesc:
    'Core cookies required for the platform to function securely (e.g., session management, checkout). Cannot be disabled.',
  cookiesRowAnalytics: 'Analytics',
  cookiesRowAnalyticsDesc:
    'Helps us understand how visitors interact with the platform by collecting and reporting information anonymously.',
  cookiesRowMarketing: 'Marketing',
  cookiesRowMarketingDesc: 'Used to track visitors across websites to display relevant advertisements.',
  cookiesSaved: 'Preferences saved.',
  cookiesSave: 'Save preferences',

  cookiesInUseTitle: 'Cookies in use',
  cookiesColName: 'Name',
  cookiesColProvider: 'Provider',
  cookiesColPurpose: 'Purpose',
  cookiesColType: 'Type',
  cookiesColExpiry: 'Expiry',

  cookiesGroupEssential: 'Essential (strictly necessary)',
  cookiesGroupAnalytics: 'Analytics & performance',
  cookiesGroupMarketing: 'Marketing & targeting',

  cookieSessionPurpose: 'Maintains active user session state.',
  cookieCsrfPurpose: 'Prevents Cross-Site Request Forgery attacks.',
  cookieGaPurpose: 'Registers a unique ID to generate statistical data.',
  cookiePerfPurpose: 'Monitors terminal load times and latency.',
  cookieFbpPurpose: 'Tracks conversions and targets ad delivery.',

  cookieExpirySession: 'Session',
  cookieExpiry1Day: '1 Day',
  cookieExpiry2Years: '2 Years',
  cookieExpiryPersistent: 'Persistent',
  cookieExpiry3Months: '3 Months',
  cookieTypeHttp: 'HTTP',
  cookieTypeLocalStorage: 'HTML5 Local Storage',

  cookiesNotes:
    'Changing these settings may require a page reload to fully take effect. For a complete overview of how we handle your data, please review our full policy.',
  cookiesReadFullPolicy: 'Read full privacy policy',

  // Terms page
  termsTitle: 'Terms & Conditions',
  termsUpdated: 'last updated: 15 May 2026',
  termsContents: 'Contents',
  termsLegalPre: 'For any legal inquiries regarding these terms, please contact',
  termsNeedAssistanceTitle: 'Need assistance?',
  termsNeedAssistanceBody: 'If you have questions about these terms, our support team is here to help.',
  termsContactSupport: 'Contact support',

  termsS1Title: 'Acceptance',
  termsS1P1:
    'By accessing or using the PixelKey platform, you signify your agreement to these Terms & Conditions. If you do not agree to these terms, you may not access or use the platform.',
  termsS1P2:
    'These terms govern your use of the marketplace, including the purchase, delivery, and redemption of digital keys. We reserve the right to update these terms at any time.',
  termsS1L1: 'You must be at least 18 years old or have parental consent.',
  termsS1L2: 'You are responsible for maintaining the confidentiality of your account credentials.',

  termsS2Title: 'License',
  termsS2P1:
    "Upon successful payment, PixelKey grants you a non-exclusive, non-transferable license to use the purchased digital product key in accordance with the respective publisher's end-user license agreement (EULA).",

  termsS3Title: 'Restrictions',
  termsS3P1:
    'You agree not to use the platform for any unlawful purpose, to resell keys obtained in breach of these terms, to attempt to circumvent security or rate-limiting controls, or to interfere with the normal operation of the service.',
  termsS3P2:
    'Automated scraping, reselling, or bulk extraction of keys or listings without our written consent is prohibited.',

  termsS4Title: 'Delivery',
  termsS4P1:
    'Products sold on PixelKey are digital activation keys delivered electronically. Once your payment has cleared, the key is made available in your account under “My Orders”, typically within seconds.',
  termsS4P2:
    'You are responsible for activating your key on the correct platform (e.g. Steam, Epic Games) and for reviewing any regional restrictions shown on the product page prior to purchase.',

  termsS5Title: 'Refunds',
  termsS5P1:
    'Because digital keys are non-recoverable once revealed, refunds are only available for keys that have not been revealed or activated. Revealing a key constitutes consumption of the digital product and waives the right of withdrawal.',
  termsS5P2:
    'If a key is faulty or cannot be activated for reasons attributable to PixelKey, contact our support team and we will investigate and, where appropriate, issue a replacement or refund.',

  termsS6Title: 'Liability',
  termsS6P1:
    'To the maximum extent permitted by law, PixelKey shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of the platform, even if advised of the possibility of such damages.',

  termsS7Title: 'Termination',
  termsS7P1:
    'We may suspend or terminate your account at any time if you breach these terms or if we reasonably believe your account is engaged in fraudulent or abusive activity. You may close your account at any time from your account settings.',

  termsS8Title: 'Changes',
  termsS8P1:
    'We reserve the right to modify these terms at any time. Material changes will be reflected in the “last updated” date above, and your continued use of the platform after changes take effect constitutes acceptance of the revised terms.',

  termsS9Title: 'Governing law',
  termsS9P1:
    'These terms are governed by and construed in accordance with the laws of Latvia, and you submit to the non-exclusive jurisdiction of the courts located there for the resolution of any disputes.',

  termsS10Title: 'Contact',
  termsS10P1:
    'Questions about these Terms & Conditions can be directed to our support team. We aim to respond to all legal and account inquiries within two business days.',
};
